import { Injectable } from '@angular/core';
import { DeficiencyTicketWatcher } from 'src/app/_model/deficiency-ticket-watcher';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class DeficiencyTicketWatchersDaoService implements Resetable {
  public abstract saveDeficiencyTicketWatchers(entries: DeficiencyTicketWatcher[]): Promise<void>;
  public abstract createDeficiencyTicketWatcher(entry: DeficiencyTicketWatcher): Promise<DeficiencyTicketWatcher>;
  public abstract getDeficiencyTicketWatchers(): Promise<DeficiencyTicketWatcher[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
